import { takeEvery, all, put, call } from "redux-saga/effects";
import * as action from "../redux/actionsTypes/Types";
import * as type from "../redux/actionsTypes/Types";
import {
  createdCVFetchData,
  fetchAllProjectData,
  masterFetchData,
  userFetchDate,
} from "../api/services/MasterServices";
import {
  appSettingsAction,
  designationAction,
  frameWorkAction,
  googleComponentsAction,
  ideAction,
  operatingSystemsAction,
  otherSkillsAction,
  projectDataFailed,
  projectDataSuccess,
  responsibilityAction,
  technologyAction,
  toolAction,
  userAction,
  versionControlAction,
  webServicesAction,
  dashboardCountAction,
  vendorAction,
  createdCVAction,
} from "../redux/actions/MasterActions";
import { useMasterQuery } from "../api/query/useMasterQuery";

//worker saga
//worker user
function* loadUsersData(action) {
  let payload1 = {};
  if (action.payload.condition) {
    payload1 = {
      searchValue: action.payload.searchValue,
      pageNo: action.payload.pageNo,
      pageSize: action.payload.pageSize,
    };
  } else {
    payload1 = { from: action.payload.from, to: action.payload.to };
  }

  try {
    const { data } = yield call(
      action.payload.condition ? masterFetchData : userFetchDate,
      "user",
      payload1
    );
    let payload = {};
    yield put(
      userAction(
        type.USERS_TABLE_DATA_SUCCESS,

        (payload = {
          data: action.payload.condition ? data.data.data : data.data,
          count: data.data.count,
          message: data.message,
        })
      )
    );
  } catch (error) {
    yield put(userAction(type.USERS_TABLE_DATA_FAILED, error.response, []));
  }
}
//worker user
function* loadProjectData(action) {
  try {
    const { data } = yield call(
      fetchAllProjectData,
      action.userId,
      action.searchValue,
      action.pageNo,
      action.pageSize
    );

    yield put(
      projectDataSuccess(data?.data?.data, data.data.count, data.message)
    );
  } catch (error) {
    yield put(projectDataFailed(error.response, []));
  }
}

//worker user
function* loadDesignationData(action) {
  let payload1 = {};
  payload1 = {
    searchValue: action.payload.searchValue,
    pageNo: action.payload.pageNo,
    pageSize: action.payload.pageSize,
  };
  try {
    const { data } = yield call(
      masterFetchData,
      "designation",
      payload1
      // action.payload.searchValue,
      // action.payload.pageNo,
      // action.payload.pageSize
    );
    let payload = {};
    yield put(
      designationAction(
        type.DESIGNATION_TABLE_DATA_SUCCESS,
        (payload = {
          data: data.data.data,
          count: data.data.count,
          message: data.message,
        })
      )
    );
  } catch (error) {
    yield put(
      designationAction(type.DESIGNATION_TABLE_DATA_FAILED, error.response)
    );
  }
}
//worker user
function* loadToolData(action) {
  let payload1 = {};
  payload1 = {
    searchValue: action.payload.searchValue,
    pageNo: action.payload.pageNo,
    pageSize: action.payload.pageSize,
  };
  try {
    const { data } = yield call(masterFetchData, "tool", payload1);
    let payload = {};
    yield put(
      toolAction(
        type.TOOLS_TABLE_DATA_SUCCESS,
        (payload = {
          data: data.data.data,
          count: data.data.count,
          message: data.message,
        })
      )
    );
  } catch (error) {
    yield put(toolAction(type.TOOLS_TABLE_DATA_FAILED, error.response));
  }
}
//worker technology
function* loadTechnologyData(action) {
  let payload1 = {};
  payload1 = {
    searchValue: action.payload.searchValue,
    pageNo: action.payload.pageNo,
    pageSize: action.payload.pageSize,
  };
  try {
    const { data } = yield call(masterFetchData, "coding-language", payload1);
    let payload = {};
    yield put(
      technologyAction(
        type.TECHNOLOGY_TABLE_DATA_SUCCESS,
        (payload = {
          data: data.data.data,
          count: data.data.count,
          message: data.message,
        })
      )
    );
  } catch (error) {
    yield put(
      technologyAction(type.TECHNOLOGY_TABLE_DATA_FAILED, error.response, [])
    );
  }
}
//worker framework
function* loadFrameworkData(action) {
  let payload1 = {};
  payload1 = {
    searchValue: action.payload.searchValue,
    pageNo: action.payload.pageNo,
    pageSize: action.payload.pageSize,
  };
  try {
    const { data } = yield call(masterFetchData, "framework", payload1);
    let payload = {};
    yield put(
      frameWorkAction(
        type.FRAMEWORK_TABLE_DATA_SUCCESS,
        (payload = {
          data: data.data.data,
          count: data.data.count,
          message: data.message,
        })
      )
    );
  } catch (error) {
    yield put(
      frameWorkAction(type.FRAMEWORK_TABLE_DATA_FAILED, error.response, [])
    );
  }
}
//worker user
function* loadIdeData(action) {
  let payload1 = {};
  payload1 = {
    searchValue: action.payload.searchValue,
    pageNo: action.payload.pageNo,
    pageSize: action.payload.pageSize,
  };
  try {
    const { data } = yield call(masterFetchData, "ide", payload1);
    let payload = {};

    yield put(
      ideAction(
        type.IDE_TABLE_DATA_SUCCESS,
        (payload = {
          data: data.data.data,
          count: data.data.count,
          message: data.message,
        })
      )
    );
  } catch (error) {
    yield put(ideAction(type.IDE_TABLE_DATA_FAILED, error.response, []));
  }
}
//worker responsibility
function* loadResponsibilityData(action) {
  let payload1 = {};
  payload1 = {
    searchValue: action.payload.searchValue,
    pageNo: action.payload.pageNo,
    pageSize: action.payload.pageSize,
  };
  try {
    const { data } = yield call(masterFetchData, "responsibility", payload1);
    let payload = {};
    yield put(
      responsibilityAction(
        type.RESPONSIBILITY_TABLE_DATA_SUCCESS,
        (payload = {
          data: data.data.data,
          count: data.data.count,
          message: data.message,
        })
      )
    );
  } catch (error) {
    yield put(
      responsibilityAction(
        type.RESPONSIBILITY_TABLE_DATA_FAILED,
        error.response
      )
    );
  }
}
//worker version control
function* loadVersionControlData(action) {
  let payload1 = {};
  payload1 = {
    searchValue: action.payload.searchValue,
    pageNo: action.payload.pageNo,
    pageSize: action.payload.pageSize,
  };
  try {
    const { data } = yield call(masterFetchData, "version-control", payload1);
    let payload = {};

    yield put(
      versionControlAction(
        type.VERSION_CONTROL_TABLE_DATA_SUCCESS,
        (payload = {
          data: data.data.data,
          count: data.data.count,
          message: data.message,
        })
      )
    );
  } catch (error) {
    yield put(
      versionControlAction(
        type.VERSION_CONTROL_TABLE_DATA_FAILED,
        error.response
      )
    );
  }
}
//worker web services
function* loadWebServicesData(action) {
  let payload1 = {};
  payload1 = {
    searchValue: action.payload.searchValue,
    pageNo: action.payload.pageNo,
    pageSize: action.payload.pageSize,
  };
  try {
    const { data } = yield call(masterFetchData, "web-service", payload1);
    let payload = {};
    yield put(
      webServicesAction(
        type.WEB_SERVICES_TABLE_DATA_SUCCESS,
        (payload = {
          data: data.data.data,
          count: data.data.count,
          message: data.message,
        })
      )
    );
  } catch (error) {
    yield put(
      webServicesAction(type.WEB_SERVICES_TABLE_DATA_FAILED, error.response, [])
    );
  }
}
//worker other skills
function* loadOtherSkillsData(action) {
  let payload1 = {};
  payload1 = {
    searchValue: action.payload.searchValue,
    pageNo: action.payload.pageNo,
    pageSize: action.payload.pageSize,
  };
  try {
    const { data } = yield call(masterFetchData, "skill", payload1);
    let payload = {};
    yield put(
      otherSkillsAction(
        type.OTHER_SKILLS_TABLE_DATA_SUCCESS,
        (payload = {
          data: data.data.data,
          count: data.data.count,
          message: data.message,
        })
      )
    );
  } catch (error) {
    yield put(
      otherSkillsAction(type.OTHER_SKILLS_TABLE_DATA_FAILED, error.response)
    );
  }
}
//worker operating systems
function* loadOperatingSystemData(action) {
  let payload1 = {};
  payload1 = {
    searchValue: action.payload.searchValue,
    pageNo: action.payload.pageNo,
    pageSize: action.payload.pageSize,
  };
  try {
    const { data } = yield call(masterFetchData, "os", payload1);
    let payload = {};
    yield put(
      operatingSystemsAction(
        type.OPERATING_SYSTEMS_TABLE_DATA_SUCCESS,
        (payload = {
          data: data.data.data,
          count: data.data.count,
          message: data.message,
        })
      )
    );
  } catch (error) {
    yield put(
      operatingSystemsAction(
        type.OPERATING_SYSTEMS_TABLE_DATA_FAILED,
        error.response
      )
    );
  }
}
//worker google component
function* loadGoogleComponentData(action) {
  let payload1 = {};
  payload1 = {
    searchValue: action.payload.searchValue,
    pageNo: action.payload.pageNo,
    pageSize: action.payload.pageSize,
  };
  try {
    const { data } = yield call(
      masterFetchData,
      "external-component",
      payload1
    );
    let payload = {};
    yield put(
      googleComponentsAction(
        type.GOOGLE_COMPONENTS_TABLE_DATA_SUCCESS,
        (payload = {
          data: data.data.data,
          count: data.data.count,
          message: data.message,
        })
      )
    );
  } catch (error) {
    yield put(
      googleComponentsAction(
        type.GOOGLE_COMPONENTS_TABLE_DATA_FAILED,
        error.response,
        []
      )
    );
  }
}
//worker vendor
function* loadVendorData(action) {
  let payload1 = {};
  payload1 = {
    searchValue: action.payload.searchValue,
    pageNo: action.payload.pageNo,
    pageSize: action.payload.pageSize,
  };
  try {
    const { data } = yield call(masterFetchData, "vendor", payload1);
    let payload = {};
    yield put(
      vendorAction(
        type.VENDOR_TABLE_DATA_SUCCESS,
        (payload = {
          data: data.data.data,
          count: data.data.count,
          message: data.message,
        })
      )
    );
  } catch (error) {
    yield put(vendorAction(type.VENDOR_TABLE_DATA_FAILED, error.response, []));
  }
}

//Created CV
function* loadCreatedCVData(action) {
  let payload1 = {};
  payload1 = {
    searchValue: action.payload.searchValue,
    pageNo: action.payload.pageNo,
    pageSize: action.payload.pageSize,
  };

  try {
    const { data } = yield call(createdCVFetchData, "cv", payload1);
    let payload = {};
    yield put(
      createdCVAction(
        type.CREATED_CV_DATA_SUCCESS,
        (payload = {
          data: data.data.data,
          count: data.data.count,
          message: data.message,
        })
      )
    );
  } catch (error) {
    yield put(createdCVAction(type.CREATED_CV_DATA_FAILED, error.response, []));
  }
}

//worker app setting
function* loadAppsettingData(action) {
  let payload1 = {};
  payload1 = {
    searchValue: action.payload.searchValue,
    pageNo: action.payload.pageNo,
    pageSize: action.payload.pageSize,
  };
  try {
    const { data } = yield call(masterFetchData, "app-setting", payload1);
    let payload = {};
    // yield put(
    //   appSettingsAction(
    //     type.APP_SETTING_TABLE_DATA_SUCCESS,
    //     payload={
    //       data:data.data.data,
    //       count:data.data.count,
    //       message:data.message
    //     }
    //   )
    //   )
  } catch (error) {
    yield put(
      appSettingsAction(type.APP_SETTING_TABLE_DATA_FAILED, error.response, [])
    );
  }
}

// watcher saga
function* watchFrameWork() {
  yield takeEvery(action.FRAMEWORK_TABLE_DATA_START, loadFrameworkData);
}
function* watchTechnology() {
  yield takeEvery(action.TECHNOLOGY_TABLE_DATA_START, loadTechnologyData);
}
function* watchUser() {
  yield takeEvery(action.USERS_TABLE_DATA_START, loadUsersData);
}
function* watchIDE() {
  yield takeEvery(action.IDE_TABLE_DATA_START, loadIdeData);
}
function* watchVersionControl() {
  yield takeEvery(
    action.VERSION_CONTROL_TABLE_DATA_START,
    loadVersionControlData
  );
}
function* watchWebServices() {
  yield takeEvery(action.WEB_SERVICES_TABLE_DATA_START, loadWebServicesData);
}
function* watchOtherSkills() {
  yield takeEvery(action.OTHER_SKILLS_TABLE_DATA_START, loadOtherSkillsData);
}
function* watchOperatingSystem() {
  yield takeEvery(
    action.OPERATING_SYSTEMS_TABLE_DATA_START,
    loadOperatingSystemData
  );
}
function* watchGoogleComponent() {
  yield takeEvery(
    action.GOOGLE_COMPONENTS_TABLE_DATA_START,
    loadGoogleComponentData
  );
}
function* watchAppSetting() {
  yield takeEvery(action.APP_SETTING_TABLE_DATA_START, loadAppsettingData);
}
function* watchProject() {
  yield takeEvery(action.PROJECT_TABLE_DATA_START, loadProjectData);
}
function* watchVendor() {
  yield takeEvery(action.VENDOR_TABLE_DATA_START, loadVendorData);
}

function* watchCreatedCV() {
  yield takeEvery(action.CREATED_CV_DATA_START, loadCreatedCVData);
}

function* watchResponsibility() {
  yield takeEvery(
    action.RESPONSIBILITY_TABLE_DATA_START,
    loadResponsibilityData
  );
}
function* watchDesignation() {
  yield takeEvery(action.DESIGNATION_TABLE_DATA_START, loadDesignationData);
}
function* watchTool() {
  yield takeEvery(action.TOOLS_TABLE_DATA_START, loadToolData);
}

export function* mastersSaga() {
  yield all([
    watchUser(),
    watchTechnology(),
    watchFrameWork(),
    watchIDE(),
    watchVendor(),
    watchCreatedCV(),
    watchVersionControl(),
    watchWebServices(),
    watchOtherSkills(),
    watchOperatingSystem(),
    watchGoogleComponent(),
    watchAppSetting(),
    watchProject(),
    watchResponsibility(),
    watchDesignation(),
    watchTool(),
  ]);
}

// action.payload.searchValue,
//   action.payload.pageNo,
//   action.payload.pageSize,
